import tracker from '../../../../service/tracker';
import { filterNavigation } from '../../../../service/clientNavigation';
import { EVENTS_MAPPING } from '../../../../utils/constants';
import ACTION_TYPES from '../../../context/actionTypes';

export const applyFilter = ({
    filterId,
    value,
    activeFilters,
    selectedFilters,
    setCollapseCarousel,
    dispatch,
    allFilters,
    isLastStep,
    stepNum
}) => {

    changeActiveFiltersContext({ value, activeFilters, selectedFilters, filterId, allFilters, dispatch });
    navigate({ isLastStep, setCollapseCarousel, filterId, value, activeFilters, stepNum });
};

const navigate = ({ isLastStep, setCollapseCarousel, filterId, value, activeFilters, stepNum }) => {
    isLastStep && setCollapseCarousel(true);
    tracker.trackFilter(EVENTS_MAPPING.FILTERS_APPLY, { id: filterId, value, location: 'Top Tile', stepNum });
    filterNavigation({ [filterId]: value }, activeFilters);
};

const changeActiveFiltersContext = ({ value, activeFilters, selectedFilters, filterId, allFilters, dispatch }) => {
    const filterValue = Array.isArray(value) ? value : [value];
    const active = { ...activeFilters, [filterId]: filterValue };
    const selectedFiltersValue = allFilters.filter((el) => filterValue.includes(el.id));
    const selected = [ ...selectedFilters, ...selectedFiltersValue];
    dispatch({ type: ACTION_TYPES.FILTER_APPLIED, active, selected });
};
